import { render } from "./ExportConfig.vue?vue&type=template&id=27103a2e&scoped=true&ts=true"
import script from "./ExportConfig.vue?vue&type=script&lang=ts"
export * from "./ExportConfig.vue?vue&type=script&lang=ts"

import "./ExportConfig.vue?vue&type=style&index=0&id=27103a2e&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27103a2e"]])

export default __exports__